import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

export type ReservationDocumentKind = '' | 'boarding_pass';

export interface ReservationDocumentKindDialogResult {
	kind: ReservationDocumentKind;
}

export interface ReservationDocumentKindOption {
	label: string;
	value: ReservationDocumentKind;
}

export const RESERVATION_DOCUMENT_KIND_OPTIONS: ReservationDocumentKindOption[] = [
	{ label: 'Brak', value: '' },
	{ label: 'Karta pokładowa', value: 'boarding_pass' },
];

@Component({
	selector: 'app-reservation-document-kind-dialog',
	standalone: true,
	imports: [MatDialogModule, MatButtonModule, MatFormFieldModule, MatSelectModule, ReactiveFormsModule],
	templateUrl: './reservation-document-kind-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReservationDocumentKindDialogComponent {
	readonly kindControl = new FormControl<ReservationDocumentKind>('', { nonNullable: true });
	readonly options = RESERVATION_DOCUMENT_KIND_OPTIONS;

	readonly dialogRef = inject(MatDialogRef);

	cancel(): void {
		this.dialogRef.close();
	}

	confirm(): void {
		this.dialogRef.close({ kind: this.kindControl.value });
	}
}
